import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['menu']

  clickTarget() {
    this.menuTarget.classList.toggle('hidden')
  }
}
